import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { ToastContainer, toast } from 'react-toastify';
import { userActions } from '../_actions';
import ErrorMessage from '../_components/ErrorMessage';
import loginImg from '../_assets/imgs/login/login.png';
import { LOGIN_VALIDATIONS } from '../_validations/userRegister';
import Header from '../_components/Header';

const LoginPage = () => {
  const dispatch = useDispatch();
  const registering = useSelector((state) => state.authentication.isLoading);
  const formSchema = Yup.object().shape({ ...LOGIN_VALIDATIONS });
  const validationOpt = { resolver: yupResolver(formSchema) };
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm(validationOpt);

  function onFormSubmit(data) {
    dispatch(userActions.login(data, toast));
    return false;
  }

  return (
    <div className="login">
      <ToastContainer autoClose={false} theme="colored" />

      <Header without />
      <div className="container">
        <div className="row">
          <div className="col-md-8 offset-md-2">
            <div className="col-md-6 d-none d-md-block paddingless">
              <img
                src={loginImg}
                style={{ borderRadius: '50px' }}
                alt="Login"
              />
            </div>
            <div className="col-md-6">
              <h2 className="text-center title-login">¡Hola de nuevo!</h2>
              <h3 className="text-center signin">Iniciar sesión</h3>

              <form onSubmit={handleSubmit(onFormSubmit)} noValidate>
                <div
                  className={`form-group${errors.email ? ' has-error' : ''}`}
                >
                  <label htmlFor="email">Correo electrónico</label>
                  <input
                    type="text"
                    className="form-control"
                    name="email"
                    disabled={registering}
                    {...register('email')}
                    placeholder="usuario@correo.com"
                    autoComplete="off"
                  />
                  <ErrorMessage error={errors.email} />
                </div>
                <div
                  className={`form-group${errors.password ? ' has-error' : ''}`}
                >
                  <label htmlFor="password">Contraseña</label>
                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    disabled={registering}
                    {...register('password')}
                    placeholder="**************"
                    autoComplete="off"
                  />
                  <ErrorMessage error={errors.password} />
                </div>

                <div className="form-group text-center">
                  <div className="forget margin-bottom-56">
                    <Link className="" to="/recover">
                      Olvidé mi contraseña
                    </Link>
                  </div>
                  <button className="btn btn-primary" disabled={registering}>
                    Enviar
                  </button>
                  {registering && (
                    <img
                      src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
                      alt="Cargando"
                    />
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { LoginPage };
